<script lang="ts" setup>
import IconLeft from '@lahaus-roomie/roomie/src/assets/icons/left.svg'
import LaHausLogo from '@lahaus-roomie/roomie/src/assets/icons/lahaus-logo.svg'
import LahausWhiteLogo from '@lahaus-roomie/roomie/src/assets/icons/la-haus-white.svg'

import type { Props } from './types.ts'

withDefaults(defineProps<Props>(), {
  isHeaderBlock: false
})

const { t } = useI18n()
const emit = defineEmits(['goHome', 'goBack'])
</script>

<script lang="ts">
export default {
  name: 'OnboardingHeader'
}
</script>

<template>
  <header
    class="onboarding-header w-full px-24 lg:px-40 py-16 grid grid-cols-[3.2rem_1fr] items-center"
    :class="{
      'onboarding-header--gradient': isHeaderBlock,
      'border-b border-b-carbon-light-50': !isHeaderBlock,
      'fixed top-0 left-0 w-full bg-white': isSticky
    }">
    <button
      id="onboarding-header-back-to-modal-button"
      data-lh-id="onboarding-header-back-to-modal-button"
      :aria-label="t('goBack')"
      class="w-32 h-32"
      :class="isHeaderBlock || hideBackLink ? '' : 'rounded-full bg-brand-50 p-4 box-content hover:bg-[#98ead833]'"
      @click="emit('goBack')">
      <IconLeft
        v-if="!hideBackLink"
        class="fill-primary-600 pointer-events-none"
        :class="{ 'fill-white': isHeaderBlock }" />
    </button>

    <button
      id="onboarding-header-logo-go-to-home-button"
      data-lh-id="onboarding-header-logo-go-to-home-button"
      :aria-label="t('goToHome')"
      class="place-self-center -translate-x-10"
      @click="emit('goHome')">
      <LaHausLogo
        v-if="!isHeaderBlock"
        class="pointer-events-none" />

      <LahausWhiteLogo
        v-else
        class="fill-white pointer-events-none" />
    </button>
  </header>
</template>

<style lang="scss">
.onboarding-header {
  &--gradient {
    @apply pt-16 pb-32;

    background: linear-gradient(0deg, #10141400 5%,#10141400 10%,#10141499 70%,#101414cc 100%);
  }
}
</style>

<i18n src="./i18n.json" lang="json" />
